import { Container } from 'telia-front-react';
import * as React from 'react';
import UiNotice from './UiNotice';

interface SinglePanelWrapperProps {
  children: React.ReactNode;
}

export const wrapIntoSinglePanel = (
  element: React.LazyExoticComponent<any> | React.ComponentClass<any> | (() => React.JSX.Element),
  wrapperProps?: any,
  panelProps?: any,
) => {
  return React.createElement(SinglePanelWrapper, wrapperProps, React.createElement(element, null, panelProps));
};

const SinglePanelWrapper = (props: SinglePanelWrapperProps): React.JSX.Element => {
  const { children } = props;

  return (
    <Container>
      <UiNotice />
      {children}
    </Container>
  );
};
